export default __webpack_public_path__ + "static/media/modern-mirror-logo.f974b9fa.svg";